import React from 'react';

/**
 * Small inline "EPF" pill — renders only when the organization has EPF enabled.
 * Use it next to organization names in lists/tables/headers so admins can spot
 * PF-running orgs at a glance.
 *
 * Usage:
 *   <span>Blogic Tech</span> <EpfBadge enabled={org.epf_enabled} />
 *   <EpfBadge enabled={epf_enabled} tone="solid" />
 */
export function EpfBadge({ enabled, tone = 'soft', className = '' }) {
  if (!enabled) return null;
  const palette = tone === 'solid'
    ? 'bg-emerald-600 text-white border-emerald-600'
    : 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/40 dark:text-emerald-300 dark:border-emerald-800';
  return (
    <span
      title="EPF enabled · ₹1,800/month deducted from employee + matching employer contribution"
      className={`inline-flex items-center align-middle text-[9px] font-semibold uppercase tracking-wide px-1.5 py-[1px] rounded-full border ${palette} ${className}`}
      data-testid="epf-badge"
    >
      EPF
    </span>
  );
}

export default EpfBadge;
